import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";
import DialogError from '../../components/dialogError'
import {UpdateTo, hideMessage} from '../../../routers/messages'

import Travel from './travel';
import Tabs from './tabs'

class fastbooking extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  componentDidUpdate(prevProps, prevState) {
    const lang = this.context.router.route.location.pathname.split('/')[1]
    const {to} = this.props.messages
    if (to !== undefined){
      this.context.router.history.push(`/${lang}${to}`);
      this.props.UpdateTo(undefined)
    }
  }

  handleClose = () => {
    this.props.hideMessage()
  };

  //<Warning style={{fill: 'orange', height: '48px', width: '48px', marginRight: '20px' }}/>
  //<CircularProgress size={60} thickness={7} />
  render() {
    return (
      <div className='col-xs-12'>
        <div className='container-fluid fast-booking'>
          <DialogError messages={this.props.messages} handleClose={this.handleClose} />
          <div className="row">
            <div className="container">
              <div className="flex-row">
                <Travel {...this.props}/>
                <Tabs/>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default connect(
	(state) => ({settings: state.settings, messages: state.messages}),
  {UpdateTo, hideMessage}
)(fastbooking)



// WEBPACK FOOTER //
// ./src/shared/routes/components/fastbooking/index.js